import { useEffect, useState } from 'react';
import './terms.css';
import TermsService from '../../service/terms/terms';
import { useNavigate } from 'react-router-dom';
import ScrollToTopButton from '../components/ScrollToTopButton';
import PageTop from '../components/pageTop/PageTop';
import styled from 'styled-components';
import Footer from '../components/footer/Footer';

interface ContentLeaf {
  clause_idx: number;
  seq: number;
  title: string;
  content: any[];
}
interface ContentItem {
  seq: number;
  title: string;
  content: ContentLeaf[] | null;
  clause_idx: number;
}
interface Term {
  seq: number;
  title: string;
  content: ContentItem[];
  terms_idx: number;
}

interface ContentItem2 {
  seq: number;
  title: string;
  content: string | null;
  clause_idx: number;
}
interface Term2 {
  seq: number;
  title: string;
  content: ContentItem2[];
  terms_idx: number;
}

type VersionItem = { version: number; create_date: string };

const LOCAL_VERSION: VersionItem = {
  version: -1,
  create_date: '2025-11-12',
};

const LOCAL_TERMS_TEXT = `
**제1조(목적)**

본 약관은 트랜스파머와 주식회사 엠딕(이하 "회사")가 제공하는 "땅집고옥션" 서비스의 이용과 관련하여 회원 또는 비회원의 서비스 이용에 관한 권리, 의무, 개인정보 보호 및 서비스 이용 조건을 명확히 하고 필요한 사항을 규정하기 위한 목적으로 합니다.

**제2조(용어의 정의)**

"서비스"란 회사가 제공하는 경매, 공매, NPL 등 부동산 관련 검색 및 분석 서비스와 기타 제공하는 인터넷 관련 제반 서비스를 의미합니다.
2. "회원"이란 본 약관에 따라 이용계약을 체결하고, 회사가 제공하는 서비스를 이용하는 고객을 말합니다.
3. "이용자"란 회원 및 비회원을 포함하여 서비스를 이용하는 모든 고객을 의미합니다.
4. "콘텐츠"란 회사 또는 회원이 서비스를 통해 제공하는 텍스트, 데이터, 이미지, 영상 등을 의미합니다.
5. "유료서비스"란 회사가 유료로 제공하는 분석 및 검색 서비스 등을 의미합니다.
6. "포인트"란 회사가 회원의 서비스 이용을 위해 제공하는 가상의 가치 단위를 의미합니다.

**제3조(약관의 게시와 효력 및 개정)**

본 약관은 서비스를 이용하는 모든 이용자에게 효력을 발생하며, 이용자가 회원 가입 시 약관에 동의함으로써 효력이 발생합니다.
2. 회사는 관련 법령을 위배하지 않는 범위 내에서 본 약관을 개정할 수 있습니다.
3. 회사가 약관을 개정할 경우, 개정 사유 및 적용 일자를 명시하여 변경 내용을 이용자가 쉽게 확인할 수 있도록 땅집고옥션 서비스에 공지합니다. 또한, 회원에게 불리한 약관 개정의 경우 최소 30일 전에 공지하며, 일반적인 경우에는 최소 7일 전에 공지합니다.
4. 기존 회원에게는 개정 약관 적용일 전, 전자우편, 로그인 시 팝업 등 전자적 수단을 통해 개별 통지할 수 있습니다. 다만, 연락처 미기재 등으로 개별 통지가 불가능한 경우에는 서비스 공지로 갈음할 수 있습니다.
5. 회원이 개정 약관의 적용일까지 명시적으로 거부 의사를 표시하지 않고 서비스를 계속 이용하는 경우, 해당 회원은 개정 약관에 동의한 것으로 간주됩니다.
6. 회원은 약관 변경에 대한 주의 의무를 다해야 하며, 변경된 약관의 미숙지로 인해 발생한 불이익에 대해서 회사는 책임지지 않습니다.

**제4조(약관의 해석)**

본 약관에서 정하지 아니한 사항이나 해석에 대해서는 관련 법령 또는 상관례에 따릅니다.

**제5조(이용계약 체결)**

이용자는 회사가 정한 절차에 따라 본 약관에 동의한 후 회원가입을 완료함으로써 이용계약이 체결됩니다.
2. 회사는 이용자의 원활한 서비스 이용을 위해 본인 확인 절차를 거칠 수 있습니다.

**제6조 (이용자의 권리와 의무)**

이용자의 권리
이용자는 회사가 제공하는 서비스를 다음과 같은 범위에서 이용할 권리를 가집니다.

(1) 서비스 이용: 땅집고옥션이 제공하는 검색, 매물 정보, 권리분석, AI 탐색 및 퀀트 분석 서비스 등을 회사가 정한 방법과 범위 내에서 이용할 수 있습니다.
(2) 정보 열람 및 자료 이용: 서비스 내 제공되는 매물 정보, 리포트, 분석 자료를 정당한 요금 결제 및 이용권 충전 범위 내에서 열람하고 활용할 수 있습니다.
(3) 유료 서비스 이용권: 이용권, 충전권, AI 탐색권 등 유료 서비스 및 혜택을 회사가 정한 조건과 기간 내에서 사용할 수 있습니다.
(4) 개인정보 보호: 서비스 이용 과정에서 제공한 개인정보를 관련 법령 및 약관에 따라 안전하게 보호받을 권리가 있습니다.
(5) 문의 및 권리 주장: 서비스 이용 중 문제 발생 시 회사에 문의하거나 이의 제기를 할 수 있습니다.
(6) 계약 해지 및 환불: 서비스 이용계약을 해지할 수 있으며, 유료 서비스는 약관 및 환불 규정에 따라 환불받을 권리가 있습니다.

2. 이용자의 의무
이용자는 서비스를 이용함에 있어 다음 각 호의 행위를 하여서는 아니 되며, 위반 시 회사는 서비스 이용 제한, 계정 정지, 민형사상 책임 등의 조치를 취할 수 있습니다.

(1) 회사 또는 서비스 운영을 방해하는 행위
(2) 타인의 정보를 도용하거나 회원 계정을 양도·판매·증여·담보 제공하는 행위
(3) 회원 가입 또는 매물 등록 시 허위 정보를 사용하는 행위
(4) 회사가 제공하지 않은 정보(컴퓨터 프로그램 등)를 송신·게시하는 행위
(5) 회사 및 제3자의 저작권, 지적재산권, 명예, 업무를 침해하는 행위
(6) 외설·폭력적·불법적 정보를 송신·게시하는 행위
(7) 사기, 악성 게시물 등록 등 거래 문화를 해치는 행위
(8) 서비스 내 개인정보 또는 매물 정보를 본래 목적 외 상업적 목적으로 사용하는 행위
(9) 서비스 정보를 무단 복제, 유통, 상업적 이용하는 행위
(10) 서비스를 비정상적인 방법으로 이용하거나 시스템에 무단 접근하는 행위
(11) 유료 서비스 요금 미지급 또는 무단 사용 행위
(12) 회사 직원·운영자를 사칭하거나 타인의 명의를 도용하는 행위
(13) 바이러스, 악성 코드 등으로 시스템을 손상시키거나 혼란을 유발하는 행위
(14) 기타 현행법 위반 등 회사가 서비스 제공을 지속하지 못할 합리적 사유가 되는 행위

3. 서비스 이용계약 해지
이용자가 위 의무를 위반하거나 중대한 손해를 초래한 경우, 회사는 사전 통지 후 서비스 이용계약을 해지할 수 있으며, 필요 시 민형사상 책임을 물을 수 있습니다.

(1) 시정 요구를 수용하지 않을 경우
(2) 동일 또는 다수의 의무 위반 행위가 반복되는 경우
(3) 위반 행위가 중대하며 회사에 손해를 입힌 경우

**제7조 (서비스 제공자의 책임 한계)**

회사는 천재지변, 전쟁, 폭동, 전기·통신 장애, 화재, 자연재해 등 불가항력적 사유로 인해 서비스를 제공할 수 없는 경우에는 서비스 제공 중지에 대해 책임을 지지 않습니다.
2. 회사는 이용자의 귀책사유(계정 관리 소홀, 부정확한 정보 제공, 부적절한 서비스 이용 등)로 인해 발생한 서비스 이용 장애에 대해서 책임을 지지 않습니다.
3. 회사는 회원이 서비스에 게시하거나 입력한 정보, 자료, 사실의 신뢰도, 정확성, 완전성 등에 대해 고의 또는 중대한 과실이 없는 한 책임을 지지 않습니다.
4. 회사는 이용자 상호 간 또는 이용자와 제3자 간의 거래·분쟁·손해 발생에 대해 어떠한 책임도 부담하지 않으며, 해당 분쟁은 당사자 간 직접 해결하여야 합니다.
5. 회사가 제공하는 서비스 또는 자료를 통해 이용자가 얻은 정보, 분석 결과, 리포트 등과 관련하여 발생하는 손해에 대해서 회사는 책임을 지지 않습니다.
• 제공된 정보가 실제 경매·공매 물건과 상이하거나 정보 제공 이후 변동사항이 발생할 수 있으므로, 이용자는 반드시 법원 공고, 등기부등본, 물건명세서, 현황조사서, 감정평가서 등 공식 자료를 확인한 후 입찰 및 거래에 참여해야 합니다.
• 회사의 정보를 단독으로 신뢰하여 발생한 손해나 문제에 대해서 회사는 책임을 지지 않으며, 이용자는 이에 대한 이의를 제기하지 않습니다.
6. 회사는 무료로 제공하는 서비스 및 정보에 대해 “개인정보처리방침” 및 관련 법령을 준수하는 범위 내에서만 책임을 부담하며, 그 외 손해 배상 책임은 부담하지 않습니다.
7. 회사는 서비스 설비의 보수, 교체, 점검, 공사 등 정상적인 운영 과정에서 발생하는 서비스 중단·지연에 대해 고의 또는 과실이 없는 한 책임을 지지 않습니다.

**제8조 (서비스 중단 또는 종료)**

서비스 제공자는 시스템 점검, 장애, 불가항력적 사유 등으로 서비스의 전부 또는 일부를 중단할 수 있습니다.
2. 서비스 종료 시, 충분한 기간을 두어 서비스 내 공지 또는 전자우편을 통해 이용자에게 사전 통지합니다.
3. 회원은 본 약관에 명시된 환불 조건에 해당하지 않는 경우에 상기 서비스 중단에 대하여 서비스 제공의 요구, 배상을 청구할 수 없습니다.

**제9조 (분쟁 해결 및 준거법)**

이용자 상호 간 분쟁에서 발생하는 문제에 대하여 일체의 책임을 지지 않습니다. 이용자 상호 간 분쟁은 당사자 간에 직접 해결해야 합니다.
2. 이용자 상호 간에 서비스 이용과 관련하여 발생한 분쟁에 대하여 이용자의 피해 구제 신청이 있는 경우에는 공정거래위원회 또는 시·도지사가 의뢰하는 분쟁 조정 기관의 조정에 따를 수 있습니다.

**제10조 (약관의 변경 및 고지)**

회사는 필요 시 약관을 변경할 수 있으며, 변경 시 서비스 내 공지사항 또는 전자우편으로 이용자에게 고지합니다.
2. 변경된 약관은 고지일로부터 7일 이후 효력이 발생합니다.

**제11조 (결제 및 환불 규정)**

요금제 이용 안내
1) 모든 요금제 금액에는 부가가치세가 포함되어 있습니다.
2) 지역권 구매 시 일부 지역 서비스는 제한될 수 있습니다.
3) 이용기간 안내
- 1개월 상품은 구매일 기준 30일간 이용 가능합니다.
- 3개월 이상 전국 스탠다드 요금제 구매 시, 퀀트 리포트 열람권, 알고리즘 만들기 이용권, AI 탐색권 등 이용권은 요금제 가입일 기준 매월 지급됩니다.
- 모든 이용권은 지급일로부터 30일 내에만 사용 가능하며, 이월 또는 누적되지 않습니다. 이용기간 종료 시 남은 이용권은 자동 소멸됩니다.
- 1년권(365일) 상품의 경우, 총 12회에 걸쳐 순차적으로 이용권이 지급됩니다.
2. 환불 규정
1) 유료 서비스 구매 회원은 잔여 이용기간에 대해 환불 신청이 가능합니다.
- 이용권 구매 당일 미사용 건: 전액 환불 가능
- 익일부터: 정상가 기준으로 환불 수수료(20%) 및 일할 사용금액을 산정하되, 최종 환불 금액은 회원의 결제금액에서 해당 금액들을 차감하여 지급합니다.
- 할인 상품 구매 시에도 공제 금액은 정상가 기준으로 계산됩니다.
2) 환불이 불가능한 경우
- 오프라인 또는 기타 홈페이지 활동으로 무료 제공받은 경우
- 이벤트 참여 또는 당첨으로 지급받은 경우
- 유료 서비스 환불 요청 시 전체 이용기간의 50% 이상 사용된 경우
3. 환불 금액 산정 공식
1) 환불 금액 = 결제금액 - { 환불 수수료(정상가 × 20%) + 일할이용금액([정상가 × (사용일수 ÷ 전체이용일수)]) }
2) 환불 수수료에는 할인 혜택, 서비스 운영비 등이 포함됩니다.
3) 일할 계산된 사용 금액은 서비스 이용 개시일부터 환불 요청일까지 일수 기준으로 산정됩니다.
4. 이벤트, 프로모션, 무료 체험 등 특별 조건이 적용된 상품은 별도의 환불 규정이 적용될 수 있으며, 해당 조건은 별도로 고지합니다.

**제12조(이용계약의 해지)**

회원은 언제든지 회원 탈퇴를 요청할 수 있으며 회사는 즉시 탈퇴를 처리합니다.
2. 회사는 다음 각 호의 사유가 발생한 경우 이용계약을 해지할 수 있습니다.
3. 허위 정보 제공
4. 타인의 명의를 도용하여 가입한 경우
5. 서비스 운영을 방해하는 행위
6. 관련 법령을 위반한 경우
7. 이용자 의무 위반한 경우
8. 탈퇴한 회원은 동일 인증 수단으로 재가입 할 때, 탈퇴 시점부터 30일 후 재가입이 가능합니다.

**제13조(개인정보 보호)**

회사는 개인정보 보호법 등 관련 법령을 준수하여 회원의 개인정보를 보호합니다.
2. 이용자의 개인정보보호에 관해서는 관련 법령 및 회사가 정하는 “개인정보처리방침”에 정한 바에 따른다.

**제14조(서비스 이용)**

본 서비스는 회원에게 경매, 공매, NPL 관련 검색 및 분석 기능을 제공합니다.
2. 서비스는 유료 및 무료로 제공될 수 있으며, 유료서비스 이용에 관한 사항은 별도 고지됩니다.
3. 회사는 서비스 품질 개선을 위해 정기적인 점검 및 업데이트를 진행할 수 있습니다.

**제15조(서비스 변경 및 중지)**

회사는 운영상 또는 기술상의 필요에 따라 서비스 내용을 변경, 중단할 수 있습니다.
2. 서비스 변경 또는 중단 시 사전 공지하며, 무료로 제공되는 서비스에 대해서는 별도의 보상을 하지 않습니다.

**제16조(면책조항)**

회사는 천재지변 또는 이에 준하는 불가항력적 사유로 인해 서비스를 제공할 수 없는 경우, 그로 인한 서비스 중단에 대한 책임을 지지 않습니다.
2. 회사는 이용자의 귀책사유로 인해 발생한 서비스 이용 장애에 대해서는 책임을 지지 않습니다.
3. 회사는 이용자가 서비스를 통해 얻은 정보 또는 자료로 인해 발생한 손해에 대해 어떠한 책임도 지지 않습니다.
4. 회사는 회사가 제공하는 서비스망을 통해 제공되는 정보의 신뢰도, 정확성 등에 대해서는 어떠한 보장도 하지 않으며, 이에 대한 책임도 지지 않습니다.
5. 회사는 이용자가 서비스 내에 게시하거나 전송한 자료의 내용에 대해 어떠한 책임도 지지 않습니다.
6. 회사는 이용자와 제휴사(가맹점, 교육기관, 광고업체 등) 간의 거래로 발생한 분쟁이나 손해 등 제반 문제에 대해 일체의 책임을 지지 않습니다.

**제17조(손해배상)**

회사는 회원이 서비스를 이용하는 과정에서 발생한 손해에 대해 회사의 고의 또는 중과실이 없는 한 책임을 지지 않습니다.
2. 회원이 서비스 이용과 관련하여 회사에 손해를 입힌 경우, 회원은 해당 손해를 배상할 책임이 있습니다.

**제18조(분쟁 해결 및 준거법)**

회사는 이용자가 제기하는 불만 사항에 대해 신속히 처리하기 위해 노력합니다.
2. 서비스 이용과 관련하여 발생한 분쟁에 관한 소송은 회사의 본사 소재지를 관할하는 법원을 전속 관할로 합니다.

**부칙**

1. 본 이용약관은 2025년 11월 12일부터 적용되며, 종전 약관은 본 약관으로 대체됩니다.
2. 개정된 이용약관의 적용일자 이전 가입자 또한 개정된 이용약관의 적용을 받습니다.
공고일자: 2025년 10월 13일
시행일자: 2025년 11월 12일
`;

/** 간단 파서: **제X조(...)** 단위로 쪼개어 서버 스키마로 변환 */
function parseLocalToServerSchema(text: string): {
  list: Term[];
  addendum: Term2[];
} {
  const headerRe = /\*\*(.+?)\*\*/g;
  const headers: { title: string; index: number }[] = [];
  let m: RegExpExecArray | null;

  while ((m = headerRe.exec(text)) !== null) {
    // m.index는 exec 성공 시 항상 number
    headers.push({ title: (m[1] || '').trim(), index: m.index });
  }

  const blocks: { title: string; body: string }[] = [];
  for (let i = 0; i < headers.length; i++) {
    const { title, index } = headers[i];
    const end = i + 1 < headers.length ? headers[i + 1].index : text.length;
    const bodyStart = index + `**${title}**`.length;
    const body = text.slice(bodyStart, end).trim();
    blocks.push({ title, body });
  }

  let termId = -1000;
  let clauseId = -100000;

  const addendumBlockIndex = blocks.findIndex(
    (b) => b.title.indexOf('부칙') !== -1,
  );
  const termBlocks =
    addendumBlockIndex >= 0 ? blocks.slice(0, addendumBlockIndex) : blocks;
  const addendumBlock =
    addendumBlockIndex >= 0 ? blocks[addendumBlockIndex] : null;

  const list: Term[] = termBlocks.map((b, idx) => ({
    terms_idx: termId--,
    seq: idx + 1,
    title: b.title,
    content: [
      {
        clause_idx: clauseId--,
        seq: 1,
        title: b.body,
        content: [],
      },
    ],
  }));

  const addendum: Term2[] = addendumBlock
    ? [
        {
          terms_idx: termId--,
          seq: list.length + 1,
          title: addendumBlock.title,
          content: (() => {
            const lines = addendumBlock.body
              .split(/\r?\n/)
              .map((s) => s.trim())
              .filter(Boolean);

            const items: { seq: number; text: string }[] = [];
            let cur: { seq: number; text: string } | null = null;
            const headRe = /^(\d+)\.\s*(.*)$/;

            for (let i = 0; i < lines.length; i++) {
              const line = lines[i];
              const mm = headRe.exec(line);
              if (mm) {
                if (cur) items.push(cur);
                cur = { seq: Number(mm[1]), text: mm[2] || '' };
              } else if (cur) {
                cur.text += (cur.text ? '\n' : '') + line;
              }
            }
            if (cur) items.push(cur);

            // ✅ 중복 방지: content에서 제목 첫 줄 제거
            if (items.length === 0) {
              const all = addendumBlock.body.split('\n');
              const titleOnly = (all.shift() || '').trim();
              const rest = all.join('\n').trim();
              return [
                {
                  clause_idx: clauseId--,
                  seq: 1,
                  title: titleOnly,
                  content: rest || '',
                },
              ];
            }

            return items.map((it) => {
              const parts = it.text.split('\n');
              const titleOnly = (parts.shift() || '').trim(); // 첫 줄 = 제목
              const rest = parts.join('\n').trim(); // 나머지 = 본문
              return {
                clause_idx: clauseId--,
                seq: it.seq,
                title: titleOnly,
                content: rest || '',
              };
            });
          })(),
        },
      ]
    : [];

  return { list, addendum };
}

const ServiceTerms = () => {
  const navigate = useNavigate();

  const [versionList, setVersionList] = useState<VersionItem[]>([]);
  const [selectedDate, setSelectedDate] = useState<VersionItem | null>(null);
  const [terms, setTerms] = useState<Term[]>([]);
  const [addendum, setAddendum] = useState<Term2[]>([]);

  const getDateList = async () => {
    try {
      const res = await TermsService.version('D');
      const serverVersions: VersionItem[] = res.result ?? [];
      // 프론트 버전을 맨 앞에 두고, 기본 선택도 프론트로!
      setVersionList([LOCAL_VERSION, ...serverVersions]);
      setSelectedDate(LOCAL_VERSION); // ✅ 추가
    } catch (error) {
      console.log(error);
      // 서버 실패 시에도 프론트 버전만 노출 + 선택
      setVersionList([LOCAL_VERSION]);
      setSelectedDate(LOCAL_VERSION); // ✅ 유지
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    getDateList();
  }, []);

  const getTerms = async (version: number) => {
    try {
      if (version === LOCAL_VERSION.version) {
        const parsed = parseLocalToServerSchema(LOCAL_TERMS_TEXT);
        setTerms(parsed.list);
        setAddendum(parsed.addendum);
        return;
      }
      const res = await TermsService.terms(version, 'D');
      setAddendum(res.result.addendum);
      setTerms(res.result.list);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (selectedDate) {
      getTerms(selectedDate.version);
    } else if (versionList.length > 0) {
      getTerms(versionList[1]?.version ?? versionList[0].version);
      setSelectedDate(versionList[1] ?? versionList[0]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedDate, versionList]);

  return (
    <Container id="termsContainer">
      <ScrollToTopButton />
      <PageTop text="이용약관" />
      <div className="wrap">
        <div className="terms-inner">
          <div className="terms-title">
            <span>땅집고 옥션 서비스 이용약관</span>
            <div className="version-select">
              <select
                className="select-non-border"
                name=""
                id=""
                onChange={(e) => {
                  const v = Number(e.target.value);
                  const sel = versionList.find((it) => it.version === v);
                  if (sel) setSelectedDate(sel);
                }}
                value={selectedDate?.version ?? ''}
              >
                {versionList.map((item) => (
                  <option key={item.version} value={item.version}>
                    {item.create_date}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="terms-content-box">
            {terms.map((term) => (
              <div className="terms-content-item" key={term.terms_idx}>
                <div
                  className="terms-content-item-title"
                  dangerouslySetInnerHTML={{
                    __html: term.title.replace(/\r\n/g, '<br>'),
                  }}
                ></div>
                <div className="terms-content-item-text">
                  {term.content.map((item) => (
                    <div key={item.clause_idx}>
                      <p>
                        {item.seq}. {item.title}
                      </p>
                      {item.content &&
                        item.content.map((content) => (
                          <div style={{ fontSize: '13px', marginLeft: '4px' }}>
                            {content.seq}
                            {')'} {content.title}
                            {content.content &&
                              content.content.map((c, idx) => (
                                <div key={idx}>- {c.title}</div>
                              ))}
                          </div>
                        ))}
                    </div>
                  ))}
                </div>
              </div>
            ))}
            <div>
              <div
                className="terms-content-item-title"
                style={{ marginBottom: '6px' }}
              >
                -부칙-
              </div>
              {addendum.map((term) => (
                <div className="terms-content-item" key={term.terms_idx}>
                  <div
                    className="terms-content-item-title"
                    dangerouslySetInnerHTML={{
                      __html: term.title.replace(/\r\n/g, '<br>'),
                    }}
                  ></div>
                  <div className="terms-content-item-text">
                    {term.content.map((item) => (
                      <div key={item.clause_idx}>
                        <p>
                          {item.seq}. {item.title}
                        </p>
                        <p
                          dangerouslySetInnerHTML={{
                            __html:
                              typeof item.content === 'string'
                                ? item.content.replace(/\r\n/g, '<br>')
                                : '',
                          }}
                        ></p>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="divider" />
          <div
            className="home-button"
            onClick={() => {
              navigate('/');
            }}
          >
            홈으로
          </div>
        </div>
      </div>

      <Footer />
    </Container>
  );
};

export default ServiceTerms;

const Container = styled.div`
  width: 100%;
  height: 100%; /* 화면 높이만큼 설정 */
  overflow-y: auto; /* 세로 스크롤 가능하게 설정 */
  margin: 0 auto;
  background-color: #fff;
`;
